// extracted by mini-css-extract-plugin
export default {"box":"progress_box__XIitm","counter":"progress_counter__aCtuG","circle":"progress_circle__ve2XW","progress":"progress_progress__YzLku"};